// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"161":"a8643d00","320":"06733cb5","534":"89b6b80a","820":"89b6b80a","881":"06733cb5"}[chunkId] + ".css";
};